import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let FoodController = {

    createCategory: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/category/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    editCategory: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/category/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    searchCategory: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/category/search`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    detailCategory: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/category/detail/${id}`,
            method: 'GET'
        }, callback)
    },
    deleteCategory: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/category/delete/${id}`,
            method: 'GET'
        }, callback)
    },
    // End category

    createGroup: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/group/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    editGroup: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/group/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    searchGroup: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/group/search`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    detailGroup: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/group/detail/${id}`,
            method: 'GET'
        }, callback)
    },
    deleteGroup: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/group/delete/${id}`,
            method: 'GET'
        }, callback)
    },
    // End group
    createProvider: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/provider/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    editProvider: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/provider/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    searchProvider: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/provider/search`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    detailProvider: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/provider/detail/${id}`,
            method: 'GET'
        }, callback)
    },
    deleteProvider: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/provider/delete/${id}`,
            method: 'GET'
        }, callback)
    },
    // End Provider
    createMenu: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/menu/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    editMenu: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/menu/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    searchMenu: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/menu/search`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    detailMenu: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/menu/detail/${id}`,
            method: 'GET'
        }, callback)
    },
    menuAddEat: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/menu/add-eat`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    menuRemoveEat: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/menu/remote-eat`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    // End menu
    createMenuWeek: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/menu-week/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    editMenuWeek: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/menu-week/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    searchMenuWeek: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/menu-week/search`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    detailMenuWeek: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/menu-week/detail/${id}`,
            method: 'GET'
        }, callback)
    },
    menuAddEatWeek: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/menu/add-week`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    menuRemoveEatWeek: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/menu/remote-week`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    createFood: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    editFood: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    searchFood: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/search`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    detailFood: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/detail/${id}`,
            method: 'GET'
        }, callback)
    },
    createFoodEat: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/eat/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    editFoodEat: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/eat/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    searchFoodEat: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/eat/search`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    detailFoodEat: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/food/eat/detail/${id}`,
            method: 'GET'
        }, callback)
    },
}

export default FoodController
